import React, { useCallback } from 'react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';

import { particlesConfiguration  } from 'src/utils/common/particlesConfiguration';
import 'src/styles/Particles.css';

const ParticleLayout = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return <Particles
      canvasClassName="particles"
      id="tsparticles" init={particlesInit} options={particlesConfiguration} />
};

export default React.memo(ParticleLayout);
